export default new class Calculator {
  constructor() {
    this.prepairData();
    this.ceilingCalc();
    this.wallCalc();
    this.partCalc();
    this.armstrongCalc();
    this.railCalc();
  }

  prepairData() {
    const inputs = document.querySelectorAll('input, select');

    if (!inputs.length) {
        return;
    }

    inputs.forEach(input => {
        input.addEventListener('keyup', () => {
          input.value = input.value.replace(/[^0-9\.,]/g, '');
          input.value = input.value.replace(/[,]/, '.');
        });
    });
  }

  ceilingCalc() {
    const calcs = document.querySelectorAll('.ceiling-calculator');

    calcs.forEach(calc => {
      const calcInputs = this.getInputs(calc);

      const x = calcInputs.ceiling_area;
      const y = calcInputs.ceiling_perimetr;
      const materials = [];

      materials.gkl = x * 1;
      materials.pp6027 = x * 2.9;
      materials.udlin = x * 0.2;
      materials.soedin2 = x * 0;
      materials.soedin1 = x * 1.7;
      materials.podvespryam = x * 0.7;
      materials.podveszazhim = x * 0.7;
      materials.tyaga = x * 0.7;
      materials.shurupln9 = x * 15.4;
      materials.shurup25mm = x * 23;
      materials.serpyanka = x * 1.2;
      materials.shpak = x * 0.4;
      materials.grunt = x * 0.1;
      materials.pn2827 = y * 1;
      materials.dubel = materials.podveszazhim * 2 + materials.pn2827 * 2;

      if (calcInputs.ceiling_type == 'p112') {
        materials.pp6027 = x * 3.2;
        materials.udlin = x * 0.6;
        materials.soedin2 = x * 2.3;
        materials.soedin1 = x * 0;
        materials.podvespryam = x * 1.3;
        materials.podveszazhim = x * 1.3;
        materials.tyaga = x * 1.3;
        materials.shurupln9 = x * 3.8;
        materials.shurup25mm = x * 17;
        materials.pn2827 = 0;
        materials.dubel = 0;
      }

      this.calculate('ceiling', materials);

      const inputs = calc.querySelectorAll('._calc-input');

      if (!inputs.length) {
        return;
      }

      inputs.forEach(input => {
        ['input', 'change', 'select'].forEach(event => {
          input.addEventListener(event, () => {
            this.ceilingCalc();
          })
        });
      });
    });
  }

  wallCalc() {
    const calcs = document.querySelectorAll('.wall-calculator');
    calcs.forEach(calc => {
      const calcInputs = this.getInputs(calc);

      const x = calcInputs.wall_area;
      const materials = [];

      materials.gkl = x * 1;
      materials.pn2827 = x * 0.7;
      materials.pn5040 = x * 0;
      materials.pp5050 = x * 0;
      materials.pp6027 = x * 2;
      materials.podvespryam = x * 0.7;
      materials.lentaupl = x * 0.85;
      materials.dubel = x * 3;
      materials.shurupln9 = x * 1.5;
      materials.shuruptn25 = x * 14;
      materials.lenta = x * 0.75;
      materials.shpak = x * 0.3;
      materials.grunt = x * 0.1;
      materials.minvata = x * 1;
      materials.perlgips = x * 0;

      if (calcInputs.wall_type == 'glue') {
        materials.pn2827 = x * 0;
        materials.pn5040 = x * 0;
        materials.pp5050 = x * 0;
        materials.pp6027 = x * 0;
        materials.podvespryam = x * 0;
        materials.lentaupl = x * 0;
        materials.dubel = x * 0;
        materials.shurupln9 = x * 0;
        materials.shuruptn25 = x * 0;
        materials.lenta = x * 0.75;
        materials.shpak = x * 0.3;
        materials.grunt = x * 0.1;
        materials.minvata = x * 0;
        materials.perlgips = x * 3.5;
      } else if (calcInputs.wall_type == 'c625') {
        materials.pn2827 = x * 0;
        materials.pn5040 = x * 0.7;
        materials.pp5050 = x * 2;
        materials.pp6027 = x * 0;
        materials.podvespryam = x * 0;
        materials.lentaupl = x * 1.2;
        materials.dubel = x * 1.6;
        materials.shurupln9 = x * 0;
        materials.shuruptn25 = x * 14;
        materials.lenta = x * 0.75;
        materials.shpak = x * 0.3;
        materials.grunt = x * 0.1;
        materials.minvata = x * 1;
        materials.perlgips = x * 0;
      }

      this.calculate('wall', materials);

      const inputs = calc.querySelectorAll('._calc-input');

      if (!inputs.length) {
        return;
      }

      inputs.forEach(input => {
        ['input', 'change', 'select'].forEach(event => {
          input.addEventListener(event, () => {
            this.wallCalc();
          })
        });
      });
    });
  }

  partCalc() {
    const calcs = document.querySelectorAll('.part-calculator');
    calcs.forEach(calc => {
      const calcInputs = this.getInputs(calc);

      const x = calcInputs.part_area;
      const materials = [];

      materials.gkl = 0;
      materials.pn5040 = 0;
      materials.ps5050 = 0;
      materials.shurup25 = 0;
      materials.shurup35 = 0;
      materials.shpak = 0;
      materials.lenta = 0;
      materials.dubel = 0;
      materials.lentaupl = 0;
      materials.grunt = 0;
      materials.minvata = 0;

      if (calcInputs.part_type === 'c111') {
        materials.gkl = x * 2;
        materials.pn5040 = x * 0.7;
        materials.ps5050 = x * 2;
        materials.shurup25 = x * 29;
        materials.shurup35 = x * 0;
        materials.shpak = x * 0.6;
        materials.lenta = x * 1.5;
        materials.dubel = x * 1.5;
        materials.lentaupl = x * 1.2;
        materials.grunt = x * 0.2;
        materials.minvata = x * 1;
      } else if (calcInputs.part_type === 'c112') {
        materials.gkl = x * 4;
        materials.pn5040 = x * 0.7;
        materials.ps5050 = x * 2;
        materials.shurup25 = x * 13;
        materials.shurup35 = x * 29;
        materials.shpak = x * 1;
        materials.lenta = x * 1.5;
        materials.dubel = x * 1.5;
        materials.lentaupl = x * 1.2;
        materials.grunt = x * 0.2;
        materials.minvata = x * 1;
      } else if (calcInputs.part_type === 'c113') {
        materials.gkl = x * 4;
        materials.pn5040 = x * 1.4;
        materials.ps5050 = x * 4;
        materials.shurup25 = x * 13;
        materials.shurup35 = x * 29;
        materials.shpak = x * 1;
        materials.lenta = x * 1.5;
        materials.dubel = x * 3;
        materials.lentaupl = x * 3;
        materials.grunt = x * 0.2;
        materials.minvata = x * 1;
      } else if (calcInputs.part_type === 'c114') {
        materials.gkl = x * 4.1;
        materials.pn5040 = x * 1.4;
        materials.ps5050 = x * 4;
        materials.shurup25 = x * 18;
        materials.shurup35 = x * 29;
        materials.shpak = x * 1;
        materials.lenta = x * 1.5;
        materials.dubel = x * 3;
        materials.lentaupl = x * 2.4;
        materials.grunt = x * 0.2;
        materials.minvata = x * 1;
      }

      this.calculate('part', materials);

      const inputs = calc.querySelectorAll('._calc-input');

      if (!inputs.length) {
        return;
      }

      inputs.forEach(input => {
        ['input', 'change', 'select'].forEach(event => {
          input.addEventListener(event, () => {
            this.partCalc();
          })
        });
      });
    });
  } 

  armstrongCalc() {
    const calcs = document.querySelectorAll('.armstrong-calculator');
    calcs.forEach(calc => {
      const calcInputs = this.getInputs(calc);

      const x = calcInputs.armstrong_area;
      const materials = [];

      materials.potolok = x * 2.78;
      materials.podves = x * 0.7;
      materials.t37 = x * 0.2;
      materials.t12 = x * 1.25;
      materials.t06 = x * 1.25;
      materials.l3 = x * 0.2;

      this.calculate('armstrong', materials);

      const inputs = calc.querySelectorAll('._calc-input');
      if (!inputs.length) {
        return;
      }

      inputs.forEach(input => {
        ['input', 'change', 'select'].forEach(event => {
          
          input.addEventListener(event, () => {
            this.armstrongCalc();
          })
        });
      });
    });
  } 

  railCalc() {
    const calcs = document.querySelectorAll('.rail-calculator');
    calcs.forEach(calc => {
      const calcInputs = this.getInputs(calc);

      const x = calcInputs.rail_area;
      const materials = [];

      materials.reika = x / 0.3;
      materials.traves = (x * 0.8) / 4;
      materials.ugolok = x * 0.2;
      materials.podves = x * 0.8;
      materials.vstavka = x / 3;

      this.calculate('rail', materials);

      const inputs = calc.querySelectorAll('._calc-input');

      if (!inputs.length) {
        return;
      }

      inputs.forEach(input => {
        ['input', 'change', 'select'].forEach(event => {
          input.addEventListener(event, () => {
            this.railCalc();
          })
        });
      });
    });
  } 

  getInputs(calc) {
    const inputs = calc.querySelectorAll('input, select');
    const calcInputs = {};

    inputs.forEach(function(element) {
      const name = element.getAttribute('name');
      const value = element.value;
      calcInputs[name] = value;
    });

    return calcInputs;
  }

  calculate(type, materials) {
      for (const [key, value] of Object.entries(materials)) {
        let z = `${value}`;
        z = +parseFloat(z).toFixed(1);
        const result = document.querySelector(`span.${type}-${key}`);
        if (z !== 0) {
          result.textContent = z;
          result.parentNode.style.display = 'list-item';
        } else {
          result.parentNode.style.display = 'none';
        }
      }
  }
}